import {Injectable} from "@angular/core";
import {ObservableBackendService} from "./observableBackend.service";
import {Observable} from "rxjs/Rx";
import {MailTemplateProperty} from "../domain/mailTemplateProperty";

/**
 * .
 * Created by jlado on 8/2/18.
 */
@Injectable()
export class MailTemplatePropertyService {

    constructor(private backendService: ObservableBackendService) {
    }

    public getMailTemplateProperties(): Observable<MailTemplateProperty[]> {
        return this.backendService.get("mailTemplateProperties", null);
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/service/mailTemplateProperty.service.ts
 **/